export const state = () => ({
    list: [],
    listLoading: false,
});
